const PTScience = [
    {
        title: "A probabilidade de uma segunda vaga no próximo inverno é muito alta",
        description: 'Nuno Marques dirige o centro de investigação biomédica Algarve Biomedical Center (ABC), que tem estado no centro do combate à pandemia. Ao DN, fala dessa luta dos últimos três meses, e do futuro, em que máscaras, distanciamento social e lavagem das mãos serão obrigatórios, "pelo menos nos próximos dois, três anos".',
        url: "https://www.dn.pt/edicao-do-dia/21-jun-2020/a-probabilidade-de-uma-segunda-vaga-no-proximo-inverno-e-muito-alta-12322650.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=39cc838b-17c5-41a8-8c03-5f2adfae98e8&t=20200622122746",
        publishedAt: "2020-06-21T14:35:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: "Sindicato dos Médicos acusa autoridades de falta de estratégia na região de Lisboa",
        description: "O Sindicato Independente dos Médicos (SIM) alertou para a falta de uma estratégia por parte da autoridade de saúde de Lisboa e Vale do Tejo.",
        url: "https://www.dn.pt/pais/-sindicato-dos-medicos-acusa-autoridades-de-falta-de-estrategia-na-regiao-de-lisboa-12305896.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=495385e6-ae90-461f-afb7-74be562e2fba&w=800&h=450&t=20200612203246",
        publishedAt: "2020-06-12T16:19:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: 'De voluntária nos testes ao estudo dos mistérios moleculares da covid. "Estou feliz por ter ajudado numa fase crítica"',
        description: "Sílvia Costa, investigadora do Instituto Gulbenkian de Ciência, esteve mais de dois meses como voluntária a trabalhar nos testes de diagnóstico de covid-19 no Hospital Egas Moniz. Agora regressou à base e vai começar a estudar os segredos moleculares do SARS-CoV-2.",
        url: "https://www.dn.pt/edicao-do-dia/14-jun-2020/de-voluntaria-nos-testes-ao-estudos-dos-misterios-moleculares-da-covid-estou-feliz-por-ter-ajudado-numa-fase-critica-12297069.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=d6dbc889-9737-494d-8f80-7acf5f0c3168&t=20200615161836",
        publishedAt: "2020-06-14T16:19:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: "Spray que substitui plástico premiado em Bruxelas",
        description: "Um spray criado por portugueses para substituir o plástico na conservação dos alimentos e reduzir as embalagens, foi premiado em Bruxelas, no concurso de Inovação Social da Comissão Europeia, recebendo uma bolsa de 50 mil euros.",
        url: "https://pt.euronews.com/2019/11/11/spray-que-substitui-plastico-premiado-em-bruxelas",
        image: "https://static.euronews.com/articles/stories/04/29/29/28/808x454_cmsv2_e6902746-a9b0-5359-9c43-06a3dba62263-4292928.jpg",
        publishedAt: "2020-06-17T18:18:00Z",
        source: {
            name: "Euronews",
            url: "https://pt.euronews.com/"
        }
    },
    {
        title: "Parque Natural do Montesinho vai ser um centro de ciência e turismo",
        description: "O anunciado Observatório de Montesinho vai arrancar com 2,5 milhões de euros para fazer do parque natural do distrito de Bragança um centro de ciência e turismo a funcionar dentro de um ano, divulgaram esta sexta-feira os responsáveis.",
        url: "https://www.jn.pt/local/noticias/braganca/braganca/parque-natural-do-montesinho-vai-ser-um-centro-de-ciencia-e-turismo-12332372.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=64387146-6e70-4792-83f8-f2db633adfd1&w=744&h=495&t=20200619182308",
        publishedAt: "2020-06-23T14:58:00Z",
        source: {
            name: "Jornal de Notícias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Investigação indica que pacientes covid-19 não serão contagiosos 11 dias após adoecerem",
        description: "Um estudo realizado em Singapura revelou que a maioria dos doentes com covid-19 não podia infetar outras pessoas, 11 dias depois de apresentar sintomas da doença. A investigação foi baseada num grupo de 73 pessoas.",
        url: "https://www.jn.pt/mundo/investigacao-indica-que-pacientes-covid-19-nao-serao-contagiosos-11-dias-apos-adoecerem-12234818.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=4b263107-eb69-410a-8b51-0a319ad1c8de&w=744&h=495&t=20200525105657",
        publishedAt: "2020-06-25T17:52:00Z",
        source: {
            name: "Jornal de Notícias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Muitos sintomas, e muito variáveis. A covid-19 não é só nova, também é complexa",
        description: "Investigadoras da Universidade do Porto fizeram o primeiro grande retrato da sintomatologia e do conjunto de outras doenças que estão associadas à infeção pelo novo coronavírus, e o que encontraram foi uma espécie de caos. São necessários mais estudos, garantem.",
        url: "https://www.dn.pt/edicao-do-dia/31-mai-2020/muitos-sintomas-e-muito-variaveis-a-covid-19-nao-e-so-nova-tambem-e-complexa-12245956.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=81b926ac-8790-4d76-91b3-fa0d41342a94&w=800&h=450&t=20200601143335",
        publishedAt: "2020-06-15T13:19:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: 'Animal "mais comprido do mundo" descoberto na Austrália',
        description: "Uma criatura aquática com pelo menos 47 metros foi captada, durante uma expedição científica feita pelo Schmidt Ocean Institute, na costa da Austrália.",
        url: "https://www.jn.pt/mundo/animal-mais-comprido-do-mundo-descoberto-na-australia-12088712.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=2345c3e8-ca79-4d8f-82ad-42298e374a69&t=20200418182509",
        publishedAt: "2020-06-11T15:22:00Z",
        source: {
            name: "Jornal de Notícias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Fotografia de astronauta mostra 'fronteira' entre dia e noite",
        description: "Bob Behnken está atualmente a bordo da Estação Espacial Internacional.",
        url: "https://www.noticiasaominuto.com/tech/1519055/fotografia-de-astronauta-mostra-fronteira-entre-dia-e-noite",
        image: "https://media-manager.noticiasaominuto.com/1920/1593432229/naom_5ef9d7bc87b9b.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjk2MCwiY3JvcEhlaWdodCI6MTU5MywiY3JvcFgiOjIyNiwiY3JvcFkiOjB9LCJsYW5kc2NhcGUiOnsiY3JvcFdpZHRoIjoyNTYwLCJjcm9wSGVpZ2h0IjoxNDQwLCJjcm9wWCI6MCwiY3JvcFkiOjk2fX0=",
        publishedAt: "2020-06-06T09:12:00Z",
        source: {
            name: "Notícias ao Minuto",
            url: "https://www.noticiasaominuto.com/tech"
        }
    },
    {
        title: "Turista espacial poderá ‘passear’ no Espaço em 2023",
        description: "Bob Behnken está atualmente a bordo da Estação Espacial Internacional.",
        url: "https://www.noticiasaominuto.com/tech/1519055/fotografia-de-astronauta-mostra-fronteira-entre-dia-e-noite",
        image: "https://media-manager.noticiasaominuto.com/1920/1593432229/naom_5ef9d7bc87b9b.jpg?crop_params=eyJwb3J0cmFpdCI6eyJjcm9wV2lkdGgiOjk2MCwiY3JvcEhlaWdodCI6MTU5MywiY3JvcFgiOjIyNiwiY3JvcFkiOjB9LCJsYW5kc2NhcGUiOnsiY3JvcFdpZHRoIjoyNTYwLCJjcm9wSGVpZ2h0IjoxNDQwLCJjcm9wWCI6MCwiY3JvcFkiOjk2fX0=",
        publishedAt: "2020-06-09T09:12:00Z",
        source: {
            name: "Notícias ao Minuto",
            url: "https://www.noticiasaominuto.com/tech"
        }
    },
    {
        title: "Águas residuais vão ajudar a prever novos surtos de covid-19",
        description: "Projeto liderado pela Águas de Portugal e com a coordenação científica da Faculdade de Ciências da Universidade de Lisboa criou método para quantificar vestígios do SARS-CoV-2 nos efluentes domésticos. A ideia é estimar o número de infetadas na população a partir da carga viral nas águas residuais.",
        url: "https://www.dn.pt/edicao-do-dia/07-jun-2020/aguas-residuais-vao-ajudar-a-prever-novos-surtos-de-covid-19--12273767.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=f955c7e5-8584-4140-9093-31b83dce6258&t=20200609102526",
        publishedAt: "2020-06-12T16:13:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: "Identificado medicamento que bloqueia efeitos da doença. Testes prosseguem",
        description: "Equipa internacional de cientistas utiliza células estaminais humanas para criar fármaco que impede o novo coronavírus de infetar células saudáveis.",
        url: "https://www.dn.pt/vida-e-futuro/identificado-medicamento-que-bloqueia-efeitos-da-doenca-testes-prosseguem-12024374.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=46d131ce-cd3e-43ae-8fc0-d9058063374e&w=800&h=450&t=20200403112144",
        publishedAt: "2020-06-18T11:43:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: "Nível do mar pode subir mais de um metro em 2100",
        description: "O aquecimento global ameaça os oceanos. O nível dos mares pode subir 110 centímetros até 2100, esta é uma das conclusõeso do Grupo Intergovernamental de Peritos para a Mudança Climática, da ONU.",
        url: "https://pt.euronews.com/2019/09/25/nivel-do-mar-pode-subir-mais-de-um-metro-em-2100",
        image: "https://static.euronews.com/articles/stories/04/18/18/10/773x435_cmsv2_eaf3d906-0e23-51ee-b1aa-d754d1f900d5-4181810.jpg",
        publishedAt: "2020-06-18T11:43:00Z",
        source: {
            name: "Euronews",
            url: "https://pt.euronews.com/"
        }
    },
    {
        title: "Investigação portuguesa: cascas de banana limpam água com metais pesados",
        description: "Uma equipa de investigadores da Universidade de Aveiro descobriu que as cascas da banana são eficientes no tratamento de águas contaminadas por metais pesados.",
        url: "https://www.jn.pt/nacional/investigacao-portuguesa-cascas-de-banana-limpam-agua-com-metais-pesados-11881167.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=ff61d42e-9b36-4a10-9651-ecfda6fae5fc&w=744&h=495&t=20200303121151",
        publishedAt: "2020-05-27T13:23:00Z",
        source: {
            name: "Jornal de Noticias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Cientistas obtêm ADN de mulher que viveu há seis mil anos",
        description: 'Foi através das marcas dos dentes, deixadas numa espécie de "pastilha elástica" da Idade da Pedra, que foi possível obter o ADN e traçar o código genético da mulher, que batizaram de "Lola".',
        url: "https://www.dn.pt/vida-e-futuro/cientistas-obtem-adn-de-mulher-que-viveu-ha-seis-mil-anos-11630178.html",
        image: "https://static.globalnoticias.pt/dn/image.aspx?brand=DN&type=generate&guid=f86a8eb3-07db-4a3a-8d3c-d9cda7909904&w=800&h=450&t=20191217224220",
        publishedAt: "2020-05-25T17:33:00Z",
        source: {
            name: "Diário de Notícias",
            url: "https://www.dn.pt/"
        }
    },
    {
        title: "Cientistas alertam para cinco grandes ameaças à humanidade",
        description: "Eventos climáticos extremos, perda de biodiversidade e colapso dos ecossistemas, crises alimentares e de água, e falha na adaptação às alterações climáticas são as cinco maiores ameaças à humanidade, segundo mais de duas centenas de cientistas.",
        url: "https://www.jn.pt/nacional/uso-excessivo-de-telemovel-e-redes-sociais-aumenta-problemas-mentais-entre-jovens-11807611.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=94b3b5b1-2d1a-4b78-9d39-b41004776223&w=744&h=495&t=20200206201407",
        publishedAt: "2020-05-26T15:33:00Z",
        source: {
            name: "Jornal de Noticias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: 'Portugal usou mais de 35 mil "ratinhos" em experiências de laboratório num ano',
        description: "Um relatório da Comissão Europeia publicado, esta quarta-feira, revela o número de animais utilizados, durante o ano de 2017, em experiências de laboratório nos Estados-membros. Portugal utilizou mais de 40 mil animais e a maioria eram murganhos, ratos e peixes.",
        url: "https://www.jn.pt/nacional/portugal-usou-mais-de-35-mil-ratinhos-em-experiencias-de-laboratorio-num-ano-11797031.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=7b5f5160-7a4a-494a-8f98-657ea8cef33d&w=744&h=495&t=20200207185721",
        publishedAt: "2020-06-06T15:12:00Z",
        source: {
            name: "Jornal de Noticias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Cientistas descobrem o material mais antigo à face da terra",
        description: "Uma equipa de cientistas descobriu o que acredita ser o material mais antigo à face da terra. Poeira encontrada numa rocha espacial, que caiu na Terra nos anos 60 do século XX, tem cerca de 7,5 mil milhões de anos.",
        url: "https://www.jn.pt/mundo/cientistas-descobrem-o-material-mais-antigo-a-face-da-terra-11705588.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=93770191-7b44-45df-9fca-829713400450&t=20200114213133",
        publishedAt: "2020-06-08T112:14:00Z",
        source: {
            name: "Jornal de Noticias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Investigador de Coimbra recebe prémio da Universidade Complutense de Madrid",
        description: "O professor universitário de Coimbra João Rui Pita foi premiado pela Universidade Complutense de Madrid pelo seu trabalho de investigação na área da História da Farmácia, foi anunciado este sábado.",
        url: "https://www.jn.pt/nacional/investigador-de-coimbra-recebe-premio-da-universidade-complutense-de-madrid-11672172.html",
        image: "https://static.globalnoticias.pt/jn/image.aspx?brand=JN&type=generate&guid=2eb75e6d-a1aa-46a0-b4b3-f2cddcaae6e8&w=744&h=495&t=20200104222358",
        publishedAt: "2020-06-17T122:14:00Z",
        source: {
            name: "Jornal de Noticias",
            url: "https://www.jn.pt/"
        }
    },
    {
        title: "Avanço extraordinário da manipulação genética em embriões humanos",
        description: "Cientistas norte-americanos e sul-coreanos conseguiram modificar genes responsáveis por doença cardíaca em embriões humanos, pela primeira vez.",
        url: "https://pt.euronews.com/2017/08/03/avanco-extraordinario-da-manipulacao-genetica-em-embrioes-humanos",
        image: "https://static.euronews.com/articles/381382/773x435_381382.jpg",
        publishedAt: "2020-06-19T121:34:00Z",
        source: {
            name: "Euronews",
            url: "https://pt.euronews.com/"
        }
    },
]

export default PTScience;